import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, Box, IconButton, Link } from "@mui/material";
import styles from './styles.module.css';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';

const CancelConfirmation = ({ open, onClose }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            className={styles.modalContainer}
            sx={{
                "& .MuiDialog-paper": {
                    width: { xs: "90%", sm: "600px", md: "750px", lg: "830px" },  // Responsive width
                    height: { xs: "auto", sm: "360px" },
                    maxWidth: "830px",
                    maxHeight: "701px",
                    borderRadius: "14px !important",
                    padding: { xs: "30px", sm: "40px", md: "60px 100px", lg: "70px 150px" }, // Responsive padding
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column'
                }
            }}
        >
            <DialogTitle className={styles.header}>
                <Box className={styles.checkmark}><DoneOutlinedIcon className={styles.checkIcon} /></Box>
                <Typography variant="gothamXL" className={styles.title}>Your subscription has been cancelled</Typography>
            </DialogTitle>
            <DialogContent className={styles.content}>
                <Box className={styles.container}>
                    <Typography variant="gothamRegular" className={styles.headerText}>
                        Your clinic listing will remain active until the end of your billing period,
                        so patients can still find you until then.
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions className={styles.buttonContainer}>
                <Button variant="contained" className={styles.gotItButton} onClick={onClose}>
                    Got It
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CancelConfirmation;
